import { render, staticRenderFns } from "./SsrRliss.vue?vue&type=template&id=06fd6c22&"
import script from "./SsrRliss.vue?vue&type=script&lang=js&"
export * from "./SsrRliss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports